import { type FC, type ReactNode } from 'react';
import { Swiper } from 'dibs-pinch-zoom-swipe';

import styles from './PhotoSwiper.scss';

type Props = {
    startingPage: number;
    onPageChange: (nextPage: number, prevPage: number) => void;
    hasInfiniteLoop?: boolean;
    children: ReactNode;
};

const PhotoSwiper: FC<Props> = props => {
    const { startingPage, onPageChange, children, hasInfiniteLoop } = props;
    return (
        <Swiper
            classNames={{ wrapper: styles.swiperWrapper, item: styles.swiperItem }}
            hasInfiniteLoop={hasInfiniteLoop}
            startingPage={startingPage}
            onPageChange={onPageChange}
        >
            {children}
        </Swiper>
    );
};

export default PhotoSwiper;
